/**
 * Deletion periods. Quoted in the privacy statement (apps/web/src/legal) and
 * enforced by db/retention.sql; db/tests/retention.test.ts checks that the SQL
 * uses exactly these numbers, so the text cannot promise what the job does not do.
 */
export const RETENTION = {
  /** Sign-in log (hashed address and IP). */
  loginEventsMonths: 12,
  /** Change log: who changed what. Spec section 15. */
  changeEventsMonths: 60,
  /** Database point-in-time restore. */
  pointInTimeRestoreDays: 7,
  /** Weekly long-term database backups. */
  longTermBackupMonths: 12,
  /** Weekly table dumps in the second storage account (lifecycle rule). */
  dumpDays: 400,
  /** Removed photos stay recoverable (blob soft delete). */
  photoSoftDeleteDays: 30,
  /** Operational logs (Application Insights / Log Analytics workspace). */
  operationalLogDays: 30,
  /**
   * Tenant exports (ZIP in the backup account, container `exports`), deleted
   * by a lifecycle rule (infra/backup-storage.bicep). A download link lives
   * one hour; the file itself this long, so a club can fetch it again.
   */
  exportDays: 30,
  /**
   * Photo blobs uploaded but never registered to a damage are deleted after
   * this many hours (orphanPhotoTimer, packages/api/src/storage/orphans.ts),
   * then still recoverable for photoSoftDeleteDays.
   */
  orphanPhotoHours: 24,
  /**
   * A push device (native app installation with notifications allowed) that
   * has not re-registered for this many days is deleted by db/retention.sql.
   * The app re-registers on every start; a dead token (app removed) is
   * deleted earlier, as soon as APNs/FCM report it.
   */
  pushDeviceDays: 180,
  /**
   * A club's online sign-up (0024) that was never confirmed with its code
   * expires after SIGNUP_PENDING_HOURS and is deleted — row, history and
   * confirmation — by db/retention.sql (dbo.purge_unconfirmed_signups) this
   * many days after it was made. Concluded contracts are business records and
   * stay.
   */
  unconfirmedSignupDays: 30,
} as const;
